/* the store's content-protection app (NoSpy) cancels paste / copy / text selection on the whole page: inside text boxes
   they work again (stopped at <html>, before the app's document handlers); the rest of the page stays protected */
if (!window.__stickaPasteOK) { window.__stickaPasteOK = true; for (const t of ['paste', 'copy', 'cut', 'selectstart'])
  document.documentElement.addEventListener(t, e => { if (e.target.matches && e.target.matches('input, textarea')) e.stopPropagation(); }); }
/* Sticka city-map poster: OpenStreetMap streets (OpenFreeMap vector tiles, no key) drawn by MapLibre GL in the
 * customer's browser, a heart on the chosen spot, a title + two lines under it. One renderer for preview and print:
 * the print is the same view rendered again off-screen at a higher pixel ratio, in tiles of <= 2048 px (phones cap a
 * WebGL canvas at 4096), so the streets, their widths and the heart land exactly where the customer saw them. The
 * approved raster prints through the existing frame pairs (engine/custom_frames.py, design "city-map"). Map data
 * (c) OpenStreetMap contributors (ODbL): credited on the product page (owner: not on the print files). */
(function () {
  'use strict';
  const MAPLIBRE = 'https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl';
  const TILES = 'https://tiles.openfreemap.org/planet';
  const GLYPHS = 'https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf';
  const REVERSE = 'https://photon.komoot.io/reverse?lang=en&limit=1&';       // a pasted spot -> its area name   // results near Cairo first
  const TILE_PX = 2048;
  // colour themes: page, land, water, park, road ink, minor-road ink, text, heart
  const themes = {
    mono:  { label: 'Black & white', page: '#ffffff', land: '#ffffff', water: '#111111', park: '#e6e6e6', road: '#111111', minor: '#2a2a2a', text: '#111111', heart: '#e0262b' },
    light: { label: 'Soft grey', page: '#ffffff', land: '#ffffff', water: '#d9d9d9', park: '#eeeeee', road: '#555555', minor: '#9a9a9a', text: '#111111', heart: '#d6453d' },
    green: { label: 'Sticka green', page: '#1f4a3a', land: '#1f4a3a', water: '#143326', park: '#285a47', road: '#f4e8bd', minor: '#c9c19f', text: '#f4e8bd', heart: '#f4d75f' },
    night: { label: 'Night', page: '#111418', land: '#111418', water: '#26303a', park: '#1a2026', road: '#f2f2f2', minor: '#9aa3ab', text: '#f2f2f2', heart: '#e0262b' }
  };
  const layouts = { classic: 'Map + text', framed: 'Framed' };
  // road widths in CSS px by zoom (MapLibre interpolates; the print scales them with the pixel ratio)
  const ROADS = [
    ['minor', ['minor', 'service', 'track'], [12, .25, 15, .8, 18, 4], 'minor'],
    ['tertiary', ['tertiary'], [12, .5, 15, 1.4, 18, 6], 'road'],
    ['secondary', ['secondary'], [12, .7, 15, 1.8, 18, 8], 'road'],
    ['primary', ['primary', 'trunk'], [10, .6, 12, 1.1, 15, 2.6, 18, 11], 'road'],
    ['motorway', ['motorway'], [10, .9, 12, 1.4, 15, 3.2, 18, 13], 'road']
  ];

  function style(name) {
    const t = themes[name] || themes.mono;
    const layers = [
      { id: 'bg', type: 'background', paint: { 'background-color': t.land } },
      { id: 'park', type: 'fill', source: 'osm', 'source-layer': 'park', paint: { 'fill-color': t.park } },
      { id: 'green', type: 'fill', source: 'osm', 'source-layer': 'landcover', filter: ['in', ['get', 'class'], ['literal', ['grass', 'wood']]], paint: { 'fill-color': t.park } },
      { id: 'water', type: 'fill', source: 'osm', 'source-layer': 'water', paint: { 'fill-color': t.water } },
      { id: 'waterway', type: 'line', source: 'osm', 'source-layer': 'waterway', paint: { 'line-color': t.water, 'line-width': ['interpolate', ['exponential', 1.6], ['zoom'], 10, .5, 18, 6] } },
      { id: 'rail', type: 'line', source: 'osm', 'source-layer': 'transportation', filter: ['==', ['get', 'class'], 'rail'], paint: { 'line-color': t.minor, 'line-width': ['interpolate', ['linear'], ['zoom'], 12, .3, 18, 2], 'line-dasharray': [3, 2] } }
    ];
    for (const [id, classes, stops, ink] of ROADS)
      layers.push({ id: 'road-' + id, type: 'line', source: 'osm', 'source-layer': 'transportation',
        filter: ['all', ['in', ['get', 'class'], ['literal', classes]], ['!=', ['get', 'brunnel'], 'tunnel']],
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: { 'line-color': t[ink], 'line-width': ['interpolate', ['exponential', 1.6], ['zoom']].concat(stops) } });
    return { version: 8, glyphs: GLYPHS, sources: { osm: { type: 'vector', url: TILES } }, layers };
  }

  /* the poster geometry for a page of w x h px: where the map sits and where the text goes (layout-dependent) */
  function geometry(layout, w, h) {
    const m = Math.round(w * .045);                         // margin round the map (covers the 5 mm safe zone)
    if (layout === 'framed') return { map: [0, 0, w, h], frame: m, text: [m * 2, h * .69, w - m * 4, h * .25] };
    return { map: [m, m, w - 2 * m, Math.round(h * .70) - m], frame: 0, text: [m, h * .70, w - 2 * m, h * .27] };
  }

  function heart(g, x, y, s, color) {
    g.save(); g.translate(x, y - s * .55); g.fillStyle = color; g.beginPath();
    g.moveTo(0, s * .55);
    g.bezierCurveTo(-s * .9, -s * .05, -s * .55, -s * .75, 0, -s * .3);
    g.bezierCurveTo(s * .55, -s * .75, s * .9, -s * .05, 0, s * .55);
    g.fill(); g.restore();
  }

  function fit(g, text, max, size, font) {
    let s = size;
    g.font = font(s);
    while (s > 6 && g.measureText(text).width > max) { s *= .94; g.font = font(s); }
    return s;
  }

  const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  function dateText(d) { const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d || ''); return m ? +m[3] + ' ' + MONTHS[+m[2] - 1] + ' ' + m[1] : ''; }

  function coords(r) {
    const f = (v, p, n) => Math.abs(v).toFixed(4) + '°' + (v >= 0 ? p : n);
    return f(r.lat, 'N', 'S') + '  ' + f(r.lng, 'E', 'W');
  }

  /* page colour, frame, heart and text round the map; the map rectangle is left untouched (clear) */
  /* the small Sticka logo on the print (owner, 1 Nov 2026): one colour, 60 %, centred under the text band */
  let LOGO = null;
  function brand(g, cx, cy, h, color) {
    if (!LOGO) return;
    const w = h * LOGO.width / LOGO.height, t = document.createElement('canvas');
    t.width = Math.max(1, Math.ceil(w)); t.height = Math.max(1, Math.ceil(h));
    const x = t.getContext('2d'); x.drawImage(LOGO, 0, 0, t.width, t.height);
    x.globalCompositeOperation = 'source-in'; x.fillStyle = color; x.fillRect(0, 0, t.width, t.height);
    g.save(); g.globalAlpha = .6; g.drawImage(t, cx - w / 2, cy - h / 2, w, h); g.restore(); t.width = t.height = 0;
  }
  function loadLogo(url, done) {
    return new Promise(ok => { if (!url) return ok(); const im = new Image(); im.onload = () => { LOGO = im; ok(); if (done) done(); }; im.onerror = () => ok(); im.src = url; });
  }
  function decorate(g, r, w, h) {
    const t = themes[r.style] || themes.mono, geo = geometry(r.layout, w, h), [mx, my, mw, mh] = geo.map;
    const [tx, ty, tw, th] = geo.text;
    if (r.layout === 'framed') {                         // a page-coloured band rising over the map, then a double rule
      const grad = g.createLinearGradient(0, ty - th * .35, 0, ty + th * .2);
      grad.addColorStop(0, t.page + '00'); grad.addColorStop(1, t.page);
      g.fillStyle = grad; g.fillRect(0, ty - th * .35, w, h - ty + th * .35);
      g.strokeStyle = t.text; const f = geo.frame;
      g.lineWidth = w * .004; g.strokeRect(f, f, w - 2 * f, h - 2 * f);
      g.lineWidth = w * .0015; g.strokeRect(f + w * .009, f + w * .009, w - 2 * f - w * .018, h - 2 * f - w * .018);
    }
    if (r.heart !== false) heart(g, mx + mw / 2, my + mh / 2, w * .045, t.heart);
    g.fillStyle = t.text; g.textAlign = 'center'; g.textBaseline = 'middle';
    const cx = tx + tw / 2, serif = r.font === 'serif';
    const tf = s => (serif ? '600 ' : '') + s + 'px ' + (serif ? '"Sticka Playfair","Sticka Amiri",Georgia,serif' : '"Sticka Vibes","Sticka Amiri",cursive');
    // rows of the text band: title, the optional quote (Arabic or English), names, bottom line
    const Y = r.quote ? [.19, .43, .62, .75, .88] : [.26, 0, .53, .67, .82];   // title, quote, names, place, line
    const say = (text, y) => { g.direction = /[\u0600-\u06ff]/.test(text) ? 'rtl' : 'ltr'; g.fillText(text, cx, ty + th * y); g.direction = 'ltr'; };
    if (r.title) { const s = fit(g, r.title, tw * .9, w * (serif ? .066 : .09), tf); g.font = tf(s); say(r.title, Y[0]); }
    if (r.quote) {
      const qf = s => s + 'px "Sticka Amiri","Sticka Playfair",Georgia,serif';
      const s = fit(g, r.quote, tw * .94, w * .036, qf); g.font = qf(s); say(r.quote, Y[1]);
    }
    const sub = (r.subtitle || '').toUpperCase(), line = r.line || coords(r);
    const sf = s => '500 ' + s + 'px "Sticka Montserrat Arabic",Arial,sans-serif';
    if ('letterSpacing' in g) g.letterSpacing = Math.round(w * .004) + 'px';
    if (sub) { const s = fit(g, sub, tw * .92, w * .026, sf); g.font = sf(s); say(sub, Y[2]); }
    const when = dateText(r.date), where = [r.place, when].filter(Boolean).join('  \u00b7  ');     // "Zamalek, Cairo · 14 February 2026"
    if (where) { const s = fit(g, where, tw * .92, w * .022, sf); g.font = sf(s); say(where, Y[3]); }
    if (line) { const s = fit(g, line, tw * .92, w * .018, sf); g.font = sf(s); say(line, Y[4]); }
    if ('letterSpacing' in g) g.letterSpacing = '0px';
    // no map credit on the print (owner): the ODbL credit is on the product page only
    brand(g, w / 2, r.layout === 'framed' ? h * .942 : h * .963, h * .018, t.text);
  }

  /* web-mercator world pixels at zoom z (512 px tiles, as MapLibre) */
  function world(lng, lat, z) {
    const S = 512 * Math.pow(2, z), s = Math.sin(lat * Math.PI / 180);
    return [(lng + 180) / 360 * S, (.5 - Math.log((1 + s) / (1 - s)) / (4 * Math.PI)) * S];
  }
  function lnglat(x, y, z) {
    const S = 512 * Math.pow(2, z), n = Math.PI - 2 * Math.PI * y / S;
    return [x / S * 360 - 180, 180 / Math.PI * Math.atan(Math.sinh(n))];
  }

  function idle(map) {
    return new Promise((ok, no) => {
      const timer = setTimeout(() => no(new Error('The map took too long to load. Check your connection and try again.')), 60000);
      map.once('idle', () => { clearTimeout(timer); ok(); });
      map.triggerRepaint();
    });
  }

  /* draw the poster on `canvas` (w x h px). r.view = the preview map's width in CSS px: the print shows the same
     area at the same zoom, `ratio` times sharper, rendered tile by tile with one off-screen map */
  async function render(canvas, r, w, h, tilePx) {
    const geo = geometry(r.layout, w, h), [mx, my, mw, mh] = geo.map, ratio = mw / r.view, viewH = mh / ratio;
    const [cx, cy] = world(r.lng, r.lat, r.zoom), left = cx - r.view / 2, top = cy - viewH / 2;
    canvas.width = w; canvas.height = h;
    const g = canvas.getContext('2d'), t = themes[r.style] || themes.mono;
    g.fillStyle = t.page; g.fillRect(0, 0, w, h);
    const div = document.createElement('div');
    div.style.cssText = 'position:fixed;left:-99999px;top:0;width:200px;height:200px';
    document.body.appendChild(div);
    const map = new maplibregl.Map({ container: div, style: style(r.style), center: [r.lng, r.lat], zoom: r.zoom,
      interactive: false, attributionControl: false, pixelRatio: ratio, preserveDrawingBuffer: true, fadeDuration: 0 });
    // tiles are a whole number of CSS px (a map container is laid out in whole px: a fractional tile shifted the
    // streets a few print px at every seam); the grid may overrun the map, the clip keeps it inside
    const T = Math.max(16, Math.floor((tilePx || TILE_PX) / ratio)), cols = Math.ceil(r.view / T), rows = Math.ceil(viewH / T);
    g.save(); g.beginPath(); g.rect(mx, my, mw, mh); g.clip();
    try {
      div.style.width = T + 'px'; div.style.height = T + 'px'; map.resize();
      for (let j = 0; j < rows; j++) for (let i = 0; i < cols; i++) {
        map.jumpTo({ center: lnglat(left + (i + .5) * T, top + (j + .5) * T, r.zoom), zoom: r.zoom });
        await idle(map);
        g.drawImage(map.getCanvas(), mx + i * T * ratio, my + j * T * ratio, T * ratio, T * ratio);
      }
    } finally { g.restore(); map.remove(); div.remove(); }
    decorate(g, r, w, h);
    return canvas;
  }

  const parseLocation = t => window.StickaPlaces ? StickaPlaces.parse(t) : null;   // links / coordinates: sticka-places.js


  let libReady = null;
  function loadLib() {
    if (window.maplibregl) return Promise.resolve();
    if (!libReady) libReady = new Promise((ok, no) => {
      const css = document.createElement('link'); css.rel = 'stylesheet'; css.href = MAPLIBRE + '.css'; document.head.appendChild(css);
      const s = document.createElement('script'); s.src = MAPLIBRE + '.js'; s.onload = ok;
      s.onerror = () => { libReady = null; no(new Error('Could not load the map. Check your connection and try again.')); };
      document.head.appendChild(s);
    });
    return libReady;
  }

  function registerFonts(urls) {
    if (!window.FontFace || !document.fonts || !urls) return;
    const LATIN = 'U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+20AC,U+2122,U+2212';
    for (const [family, file, range] of [['Sticka Vibes', 'vibes-latin', LATIN], ['Sticka Playfair', 'playfair-latin', LATIN],
      ['Sticka Montserrat Arabic', 'montserrat-arabic', ''], ['Sticka Amiri', 'amiri-arabic', 'U+0600-06FF,U+0750-077F,U+08A0-08FF,U+200C-200E,U+FB50-FDFF,U+FE70-FEFF']])
      if (urls[file]) document.fonts.add(new FontFace(family, 'url(' + urls[file] + ') format("woff2")', range ? { unicodeRange: range } : {}));
  }
  function fontsReady(r) {
    if (!document.fonts) return Promise.resolve();
    const text = (r.title || '') + (r.quote || '') + (r.subtitle || '') + (r.place || '') + (r.line || '') + 'Aa';
    return Promise.all(['40px "Sticka Vibes"', '600 40px "Sticka Playfair"', '500 40px "Sticka Montserrat Arabic"', '40px "Sticka Amiri"']
      .map(f => document.fonts.load(f, text).catch(() => {})));
  }

  function init(root) {
    const q = k => root.querySelector('[data-cm="' + k + '"]'), cfg = JSON.parse(root.querySelector('[data-city-config]').textContent);
    const logoReady = loadLogo(cfg.logo, () => { try { draw(); } catch (e) {} });
    const catalog = typeof cfg.catalog === 'string' ? JSON.parse(cfg.catalog) : cfg.catalog;
    const variants = cfg.variants.filter(v => {
      const row = catalog.sizes.find(s => v.title.startsWith(s.code + ' ') || v.title.startsWith(s.code + '/'));
      const option = /white/i.test(v.title) ? 'white' : /black/i.test(v.title) ? 'black' : null;
      return row && row.available && !row.retired && option && catalog.options[option];
    });
    registerFonts(cfg.fonts);
    for (const s of new Set(variants.map(v => v.title.match(/^\d+x\d+/)[0]))) q('size').add(new Option(s.replace('x', ' × ') + ' cm', s));
    for (const [k, t] of Object.entries(themes)) q('style').add(new Option(t.label, k));
    for (const [k, t] of Object.entries(layouts)) q('layout').add(new Option(t, k));
    const first = variants.find(v => v.available) || variants[0];
    if (first) { q('size').value = first.title.match(/^\d+x\d+/)[0]; q('frame').value = /white/i.test(first.title) ? 'white' : 'black'; }
    let map = null, busy = false, lineEdited = false, placeEdited = false;
    const start = { lat: 30.0626, lng: 31.2197, zoom: 12.6 };

    function chips() {
      const money = n => (n / 100).toFixed(0) + ' ' + cfg.currency, swatch = c => '<i style="background:' + c + '"></i>';
      const look = { style: o => swatch(themes[o.value].water === '#111111' ? '#111' : themes[o.value].page) + o.text,
        layout: o => o.text, detail: o => o.text, frame: o => swatch(o.value === 'white' ? '#fff' : '#202520') + o.text.replace(' frame', ''),
        font: o => '<span style="font-family:' + (o.value === 'serif' ? "'Sticka Playfair',Georgia,serif;font-weight:600" : "'Sticka Vibes',cursive;font-size:1.5em") + '">Aa</span>' + o.text,
        size: o => { const v = variants.find(x => x.title.startsWith(o.value + ' ')); return '<span>' + o.text + '</span>' + (v ? '<small>' + money(v.price) + '</small>' : ''); } };
      root.querySelectorAll('[data-chips]').forEach(box => {
        const sel = q(box.dataset.chips); box.textContent = '';
        for (const o of sel.options) {
          const b = document.createElement('button'); b.type = 'button'; b.innerHTML = look[box.dataset.chips](o); b.dataset.value = o.value;
          b.addEventListener('click', () => { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); });
          box.append(b);
        }
      });
    }
    function sync() { root.querySelectorAll('[data-chips]').forEach(box => { const v = q(box.dataset.chips).value; box.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', b.dataset.value === v ? 'true' : 'false')); }); }
    const variant = () => variants.find(v => v.title.startsWith(q('size').value + ' ') && v.title.toLowerCase().includes(q('frame').value));
    const row = () => catalog.sizes.find(r => r.code === q('size').value);

    /* owner (3 Nov 2026): text boxes start empty with a hint; the preview shows the sample (data-sample) until the customer types, and Add to cart asks for the boxes that still show it */
    const typed=k=>q(k).value.trim()?q(k).value:(q(k).dataset.sample||''),unfilled=()=>{const e=[...root.querySelectorAll('[data-sample]')].find(e=>!e.value.trim()),pane=e&&e.closest('[data-pane]');if(pane&&pane.hidden){const t=root.querySelector('[data-tab="'+pane.dataset.pane+'"]');if(t)t.click();}return e;};
    function recipe() {
      const c = map ? map.getCenter() : { lat: start.lat, lng: start.lng };
      return { v: 1, lat: +c.lat.toFixed(6), lng: +c.lng.toFixed(6), zoom: +(map ? map.getZoom() : start.zoom).toFixed(3),
        style: q('style').value, layout: q('layout').value, font: q('font').value, title: typed('title'),
        subtitle: q('subtitle').value, quote: q('quote').value, line: lineEdited ? q('line').value : '', place: q('place').value.trim().slice(0, 80),
        heart: q('heart').checked, view: Math.round(parseFloat(q('map').style.width) || 300), detail: +q('detail').value || 1,
        date: q('date').value };
    }

    /* preview: the poster at the work area's size; the live map sits in its map rectangle, the overlay canvas draws
       the page round it */
    function layout() {
      const spec = row(); if (!spec) return;
      const r = q('work').getBoundingClientRect(), k = Math.min(Math.max(1, r.width - 56 - 100) / spec.px[0], Math.max(1, r.height - 56) / spec.px[1]);   // 2 x 50 px: the tools beside the frame, kept centred
      const W = Math.round(spec.px[0] * k), H = Math.round(spec.px[1] * k);
      q('preview').style.width = W + 'px'; q('preview').style.height = H + 'px';
      // street detail: the map is drawn D times bigger and shown at 1/D - the tiles of a higher zoom (small streets) for
      // the same area; `view` (its CSS width) carries D into the print, which needs nothing else
      const D = +q('detail').value || 1, [x, y, w, h] = geometry(q('layout').value, W, H).map, m = q('map').style, old = parseFloat(m.width);
      m.left = x + 'px'; m.top = y + 'px'; m.width = w * D + 'px'; m.height = h * D + 'px';
      m.transform = D === 1 ? '' : 'scale(' + 1 / D + ')'; m.transformOrigin = '0 0'; m.setProperty('--cm-k', D);
      // the preview grows / shrinks with the panel below it: zoom with it so the same streets stay in view
      if (map) { map.resize(); if (old && Math.abs(w * D - old) > .5) map.setZoom(map.getZoom() + Math.log2(w * D / old)); }
      draw();
    }
    function draw() {
      const c = q('deco'), W = parseFloat(q('preview').style.width) || 1, H = parseFloat(q('preview').style.height) || 1, k = Math.min(3, window.devicePixelRatio || 1);
      c.width = Math.round(W * k); c.height = Math.round(H * k);
      const g = c.getContext('2d'), r = recipe(), [x, y, w, h] = geometry(r.layout, c.width, c.height).map;
      // the page colour also behind the canvas, and the cut-out 1 px inside the map: rounding between the map element and
      // this canvas showed thin white lines round the map on dark colours
      const page = (themes[r.style] || themes.mono).page, e = Math.ceil(k);
      q('preview').style.background = page; q('map').style.background = (themes[r.style] || themes.mono).land;
      g.fillStyle = page; g.fillRect(0, 0, c.width, c.height); g.clearRect(x + e, y + e, w - 2 * e, h - 2 * e);
      decorate(g, r, c.width, c.height);
      if (!lineEdited) q('line').placeholder = coords(r);
      const v = variant(); q('price').textContent = v ? (v.price / 100).toFixed(2) + ' ' + cfg.currency : 'Unavailable';
      q('add').disabled = busy || !map || !v || !v.available; q('preview').dataset.frame = q('frame').value; sync();
    }

    async function open() {
      q('editor').hidden = false; document.documentElement.classList.add('star-map-open'); q('close').focus(); layout();
      try {
        await loadLib();
        if (!map) {
          map = new maplibregl.Map({ container: q('map'), style: style(q('style').value), center: [start.lng, start.lat], zoom: start.zoom + Math.log2(+q('detail').value || 1),
            minZoom: 3, maxZoom: 18.5, attributionControl: false, dragRotate: false, pitchWithRotate: false, touchPitch: false });
          map.touchZoomRotate.disableRotation(); map.keyboard.disableRotation();
          map.on('move', draw); map.on('load', draw);
          info('Loading the map…'); q('message').dataset.loading = '1';  // the first tiles can take a few seconds
          map.once('idle', () => { if (q('message').dataset.loading) info(''); });   // a flag, not the text: the Arabic page translates it
        }
        layout();
        fontsReady(recipe()).then(draw);
      } catch (e) { problem(e.message); }
    }

    function info(text) { delete q('message').dataset.loading; q('message').textContent = text; q('message').classList.toggle('is-info', !!text); }
    function problem(text) { q('message').textContent = text; q('message').classList.remove('is-info'); }

    /* full screen: the finished poster from the print renderer at screen size (what the frame will show) */
    let fullSeq = 0;
    async function full() {
      if (!map || busy) return;
      const seq = ++fullSeq, spec = row(), r = recipe(), v = q('full-view');
      v.hidden = false; q('full-img').removeAttribute('src'); q('full-msg').textContent = 'Preparing your poster…';
      q('full-frame').dataset.frame = q('frame').value; q('full-close').focus();
      try {
        await fontsReady(r);
        // screen-only copy: small (<= 900 px) and watermarked - a screenshot of it is no use as a print
        const w = Math.min(900, Math.max(600, Math.round(Math.min(window.innerWidth, window.innerHeight) * Math.min(2, window.devicePixelRatio || 1))));
        const c = await render(document.createElement('canvas'), r, w, Math.round(w * spec.px[1] / spec.px[0]));
        if (seq !== fullSeq || v.hidden) return;
        watermark(c);
        q('full-img').src = c.toDataURL('image/jpeg', .9); q('full-msg').textContent = '';
      } catch (e) { if (seq === fullSeq) q('full-msg').textContent = e.message || 'Could not draw the poster.'; }
    }
    function watermark(c) {
      const g = c.getContext('2d'), size = Math.round(c.width * .05), d = Math.hypot(c.width, c.height);
      g.save(); g.globalAlpha = .14; g.fillStyle = '#808080'; g.font = '700 ' + size + 'px Arial,sans-serif';
      g.textAlign = 'center'; g.textBaseline = 'middle'; g.translate(c.width / 2, c.height / 2); g.rotate(-Math.PI / 6);
      const dx = g.measureText('STICKA PREVIEW').width + size * 2, dy = size * 4;
      for (let y = -d / 2, row = 0; y < d / 2; y += dy, row++) for (let x = -d / 2 + (row % 2) * dx / 2; x < d / 2; x += dx) g.fillText('STICKA PREVIEW', x, y);
      g.restore();
    }
    function closeFull() { fullSeq++; q('full-view').hidden = true; q('full').focus(); }
    q('full').addEventListener('click', full);
    q('zoom-in').addEventListener('click', () => map && map.zoomIn());
    q('zoom-out').addEventListener('click', () => map && map.zoomOut());
    q('full-close').addEventListener('click', closeFull);
    q('full-view').addEventListener('click', e => { if (e.target === q('full-view')) closeFull(); });

    let searchTimer, searchSeq = 0;
    // the place line under the names: filled from the chosen location ("Zamalek, Cairo") until the customer edits it
    const short = p => [p.name || p.district || p.locality, p.city || p.state].filter((x, n, a) => x && a.indexOf(x) === n).slice(0, 2).join(', ');
    const withEgypt = t => !t || /(egypt|مصر)$/i.test(t) ? t : t + (/[\u0600-\u06ff]/.test(t) ? '، مصر' : ', Egypt');   // a place in Egypt: the country on the poster too (owner)
    function autoPlace(text) { if (!placeEdited && text) { q('place').value = text.slice(0, 80); draw(); } }
    async function search() {
      let text = q('search').value.trim(); const seq = ++searchSeq; q('hits').textContent = '';
      if (text.length < 3) return;
      const spot = parseLocation(text);
      if (spot && spot.short && spot.name) text = spot.name;               // a shared place: its name is searched
      else if (spot && spot.short || spot === 'link') {
        q('hits').textContent = 'This short link cannot be read here. Open it in your browser and copy the full link from the address bar, or in Google Maps press and hold the place and copy the numbers at the top (like 30.0444, 31.2357).';
        return;
      } else if (spot) {
        autoPlace(spot.name);
        if (!spot.name) fetch(REVERSE + 'lat=' + spot.lat + '&lon=' + spot.lng).then(x => x.json())
          .then(d => { const f = (d.features || [])[0]; if (f && seq === searchSeq) { const x = f.properties || {}; const t = short({ ...x, name: x.district || x.locality || x.name }); autoPlace(x.countrycode === 'EG' ? withEgypt(t) : t); } }).catch(() => {});
        if (map) map.jumpTo({ center: [spot.lng, spot.lat], zoom: spot.zoom + Math.log2(+q('detail').value || 1) });
        q('hits').textContent = 'Location set - the heart is on it.';
        return;
      }
      // owner (3 Nov 2026): areas first - our checked list of neighbourhoods (Maadi, Zamalek, Smouha... sticka-places.js)
      const ar = /[\u0600-\u06ff]/.test(text) || !/[a-z]/i.test(text) && /^ar\b/i.test(document.documentElement.lang), seen = new Set();   // labels in the language typed (owner)
      if (window.StickaPlaces) await StickaPlaces.ready();                    // the villages file, once, on the first search
      if (seq !== searchSeq) return;
      for (const a of window.StickaPlaces ? StickaPlaces.find(text, 6) : []) {
        const label = ar ? a[1] + '، ' + a[3] : a[0] + ', ' + a[2], b = document.createElement('button'); b.type = 'button'; b.textContent = label; seen.add(a[1]); seen.add(a[0]);
        b.addEventListener('click', () => {
          autoPlace(withEgypt(label)); q('hits').textContent = ''; q('search').value = label;
          if (map) map.jumpTo({ center: [a[5], a[4]], zoom: 14.5 + Math.log2(+q('detail').value || 1) });
        });
        q('hits').append(b);
      }
      try {
        const found = window.StickaPlaces ? await StickaPlaces.online(text, { lang: ar ? '' : 'en' }) : [];   // every kind of place, near Cairo first
        if (seq !== searchSeq) return;
        let feats = found.sort((a, b) => ((b.properties || {}).countrycode === 'EG') - ((a.properties || {}).countrycode === 'EG'));
        if (seen.size || feats.some(f => (f.properties || {}).countrycode === 'EG')) feats = feats.filter(f => (f.properties || {}).countrycode === 'EG');   // a place in Egypt found: no look-alikes abroad
        for (const f of feats) {
          if (seen.has((f.properties || {}).name) || q('hits').children.length >= 8) continue; seen.add((f.properties || {}).name);
          const p = f.properties || {}, label = [p.name, p.district, p.city, p.state, p.country].filter((x, n, a) => x && a.indexOf(x) === n).join(', ');
          const b = document.createElement('button'); b.type = 'button'; b.textContent = label;
          b.addEventListener('click', () => {
            autoPlace(p.countrycode === 'EG' ? withEgypt(short(p)) : short(p)); q('hits').textContent = ''; q('search').value = label;
            if (map) map.jumpTo({ center: f.geometry.coordinates, zoom: (p.osm_value === 'city' || p.type === 'state' ? 12 : p.osm_value === 'village' || p.osm_value === 'hamlet' ? 14.5 : 13.5) + Math.log2(+q('detail').value || 1) });
          });
          q('hits').append(b);
        }
        if (q('hits').children.length) { const c = document.createElement('small'); c.textContent = StickaPlaces.CREDIT; q('hits').append(c); }
        if (!q('hits').children.length) q('hits').textContent = 'Not found - try another spelling, or in Google Maps press and hold the place and paste its numbers here.';
      } catch (e) { if (!q('hits').children.length) q('hits').textContent = 'Search is not available right now - move the map yourself.'; }
    }

    q('search').addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(search, 450); });
    /* the store's content-protection app (NoSpy) cancels paste / text selection on the whole page: inside this editor
       the fields stay usable (their events stop here, before the app's document handlers) */
    for (const type of ['paste', 'copy', 'cut', 'selectstart'])
      q('editor').addEventListener(type, e => { if (e.target.matches && e.target.matches('input, textarea')) e.stopPropagation(); });
    q('style').addEventListener('change', () => { if (map) map.setStyle(style(q('style').value)); draw(); });
    for (const name of ['layout', 'size', 'detail']) q(name).addEventListener('change', layout);
    for (const name of ['frame', 'font', 'heart', 'date']) q(name).addEventListener('change', draw);
    q('date').addEventListener('input', draw);
    for (const name of ['title', 'quote', 'subtitle']) q(name).addEventListener('input', () => { draw(); fontsReady(recipe()).then(draw); });
    q('line').addEventListener('input', () => { lineEdited = q('line').value !== ''; draw(); });
    q('place').addEventListener('input', () => { placeEdited = q('place').value !== ''; draw(); fontsReady(recipe()).then(draw); });
    new ResizeObserver(layout).observe(q('work'));
    root.querySelectorAll('[data-tab]').forEach(b => b.addEventListener('click', () => {
      root.querySelectorAll('[data-tab]').forEach(n => n.setAttribute('aria-selected', n === b ? 'true' : 'false'));
      root.querySelectorAll('[data-pane]').forEach(n => n.hidden = n.dataset.pane !== b.dataset.tab); layout();
    }));
    q('start').addEventListener('click', open);
    q('close').addEventListener('click', () => { if (busy) return; q('editor').hidden = true; document.documentElement.classList.remove('star-map-open'); q('start').focus(); });
    q('editor').addEventListener('keydown', e => { if (e.key === 'Escape' && !busy) { e.preventDefault(); if (!q('full-view').hidden) closeFull(); else q('close').click(); } });
    for (const [name, d] of [['less', -1], ['more', 1]]) q(name).addEventListener('click', () => { q('quantity').value = Math.min(1000, Math.max(1, (parseInt(q('quantity').value, 10) || 1) + d)); });

    const blob = (c, type, quality) => new Promise((ok, no) => c.toBlob(b => b ? ok(b) : no(Error('Could not export poster.')), type, quality));
    q('add').addEventListener('click', async () => {
      const v = variant(), spec = row(), qty = Number(q('quantity').value), r = recipe();
      if (!map || !v || !v.available || busy) return;
      const miss = unfilled(); if (miss) { problem('Write your text in the empty box first.'); miss.focus(); return; }
      if (!Number.isInteger(qty) || qty < 1 || qty > 1000) { problem('Choose between 1 and 1000 frames.'); return; }
      busy = true; root.querySelectorAll('input,select,textarea,button').forEach(e => e.disabled = true); info('Preparing your print…');
      let failure = '';
      try {
        await fontsReady(r);
        await logoReady;
        const c = await render(document.createElement('canvas'), r, spec.px[0], spec.px[1]);
        let image = await blob(c, 'image/png');
        if (image.size > 20 * 1048576) image = await blob(c, 'image/jpeg', .95);     // dense city at 30x40
        c.width = c.height = 1;
        if (image.size > 25 * 1048576) throw Error('Print image is too large. Please zoom in a little.');
        const ext = image.type === 'image/png' ? 'png' : 'jpg', body = new FormData();
        body.set('id', v.id); body.set('quantity', qty);
        body.set('properties[Size]', spec.code.replace('x', ' × ') + ' cm'); body.set('properties[Design]', 'City map');
        if (r.place) body.set('properties[Place]', r.place);
        body.set('properties[_cutout]', image, 'city-map-print.' + ext); body.set('properties[_original]', image, 'city-map-source.' + ext);
        body.set('properties[_sticka]', JSON.stringify({ v: 1, kind: 'frame', design: 'city-map', city_map: r, size: spec.code, frame: q('frame').value, source_px: spec.px, quality_accepted: false }));
        if (window.StickaPreview) await StickaPreview.attach(body, image, { kind: 'frame', frame: q('frame').value });
        const res = await fetch(cfg.root + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } }), data = await res.json();
        if (!res.ok) throw Error(data.description || 'Could not add your frame.');
        location.assign(cfg.root + 'cart');
      } catch (e) { failure = e.message; }
      finally { busy = false; root.querySelectorAll('input,select,textarea,button').forEach(e => e.disabled = false); draw(); if (failure) problem(failure); else info(''); }
    });
    chips(); sync();
  }

  window.StickaCityMap = { themes, layouts, style, geometry, decorate, render, coords, dateText, world, lnglat, loadLib, parseLocation };
  function boot() { document.querySelectorAll('[data-city-map]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
